var exports = {
  "WX": "ViewTabContainer__S9gZgU",
  "B": "viewNameInput__rb2jfQ",
  "W2": "viewNameText__3zlGDN",
  "hq": "selectedViewNameText__N_-MJJ",
  "$w": "viewOptionsPlaceholder__vAsyBl",
  "vn": "viewTypeIcon__UikeX6",
  "Az": "selectedViewTypeIcon__i_D0Cf",
  "LL": "editable__0wi2HY",
  "S2": "nonEditable__SZZBuF",
};

module.exports = exports;
